module.exports = __webpack_public_path__ + "img/active_icon01.50314309.png";